import type { EmailActivity } from '@common/types/activities';
import { Box, Link, Typography } from '@mui/material';
import ShowLessButton from '../ShowLessButton';
import { cleanHTML } from '../util';

interface Props {
    emailBody: EmailActivity['body'];
    isBodyExpanded: boolean;
    setIsBodyExpanded: (val: boolean) => void;
}

export default function IntakeEmailBody({ emailBody, isBodyExpanded, setIsBodyExpanded }: Props) {
    return (
        <>
            {emailBody?.IntakeEmailIntroduction ? (
                <Box
                    sx={{
                        marginTop: '16px',
                        wordWrap: 'break-word',
                        overflowWrap: 'anywhere',
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            marginBottom: '16px',
                        }}
                    >
                        Intake email
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.primary',
                            marginBottom: '10px',
                        }}
                    >
                        Hi {emailBody?.ClientName || emailBody.ClientFirstName},
                    </Typography>
                    <Typography variant="body2" color="text.primary">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: cleanHTML(emailBody?.IntakeEmailIntroduction || ''),
                            }}
                        ></div>
                    </Typography>
                    <Link
                        sx={{
                            textDecoration: 'none',
                            fontSize: '14px',
                            lineHeight: '16px',
                            fontWeight: '500',
                            marginTop: '16px',
                            display: 'block',
                            cursor: 'pointer',
                        }}
                        href={emailBody?.IntakeFormLink}
                    >
                        Intake form link
                    </Link>
                    <Typography variant="body2" sx={{ color: 'text.primary', marginTop: '16px' }}>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: cleanHTML(emailBody?.IntakeEmailClosing || ''),
                            }}
                        ></div>
                    </Typography>
                    <Box mt={3}>
                        {emailBody?.Subject?.includes('draft')}
                        <Typography variant="body2" color="text.primary">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: cleanHTML(emailBody?.EmailSignature || ''),
                                }}
                            ></div>
                        </Typography>
                    </Box>
                    <ShowLessButton
                        isBodyExpanded={isBodyExpanded}
                        bodyExpandedHandler={setIsBodyExpanded}
                    />
                </Box>
            ) : (
                <Box
                    sx={{
                        marginTop: '16px',
                        wordWrap: 'break-word',
                        overflowWrap: 'anywhere',
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            marginBottom: '16px',
                        }}
                    >
                        Intake form submitted
                    </Typography>
                    {emailBody?.Clients && emailBody?.Clients?.length > 1 ? (
                        <>
                            <Typography variant="body2" sx={{ color: 'text.primary', mb: 1 }}>
                                You received the intake form for the following clients:
                            </Typography>

                            {emailBody.Clients.map((client) => (
                                <Typography
                                    key={client.number}
                                    variant="body2"
                                    color="text.primary"
                                >
                                    {`${client.number})`} {client.firstName} {client.lastName}
                                </Typography>
                            ))}
                        </>
                    ) : (
                        <Typography variant="body2" color="text.primary">
                            {emailBody?.ClientName} has completed the intake form.
                        </Typography>
                    )}
                    <Typography variant="body2" sx={{ color: 'text.primary', marginTop: '16px' }}>
                        You can access the intake information from the prospect{' '}
                        <Link
                            href={emailBody?.ProspectLink}
                            sx={{ textDecoration: 'none', cursor: 'pointer' }}
                        >
                            here
                        </Link>
                        .
                    </Typography>
                    <ShowLessButton
                        isBodyExpanded={isBodyExpanded}
                        bodyExpandedHandler={setIsBodyExpanded}
                    />
                </Box>
            )}
        </>
    );
}
